// extracted by mini-css-extract-plugin
export const bannerSection = "J_bQ";
export const banner = "J_bw";
export const bannerContent = "J_bR";
export const bannerTitle = "J_bS";
export const bannerSubTitle = "J_bT";
export const btnPromote = "J_bG";